import React, { useState } from 'react';
import { philosophyData } from '../data/mock';

const Philosophy = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="philosophy-section">
      <div className="container">
        <div className="philosophy-header">
          <h2 className="section-label">(Approach.)</h2>
        </div>

        <div className="philosophy-tabs">
          {philosophyData.map((item, index) => (
            <div
              key={item.id}
              className={`philosophy-tab ${activeIndex === index ? 'active' : ''}`}
              onMouseEnter={() => setActiveIndex(index)}
            >
              <div className="tab-number">[{item.id}]</div>
              <div className="tab-content">
                <h3 className="tab-title">{item.title}</h3>
                <p className="tab-description">{item.description}</p>
              </div>
              {activeIndex === index && (
                <div className="tab-image-wrapper">
                  <img src={item.image} alt={item.title} className="tab-image" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
